import { useQuery } from "react-query";
import { fetchReviewOfferEligibility } from "./reviewOfferEligibilityApi";
import { ReviewOfferEligibilityResponse } from "./types";

export type UseReviewOfferEligibilityArgs = {
  enabled: boolean;
  /** cache-key differentiator only — the real endpoint takes no params, client is resolved server-side from the session */
  campaignId?: string | number;
  /** true while S3 "applying" is polling for the entitlement to land */
  isPolling?: boolean;
};

const POLL_INTERVAL_MS = 2000;

export const useReviewOfferEligibility = ({
  enabled,
  campaignId,
  isPolling = false,
}: UseReviewOfferEligibilityArgs) => {
  const query = useQuery<ReviewOfferEligibilityResponse, Error>({
    queryKey: ["reviewOfferEligibility", campaignId],
    queryFn: () => fetchReviewOfferEligibility(),
    enabled,
    refetchInterval: enabled && isPolling ? POLL_INTERVAL_MS : false,
    retry: false,
    // service_error / network failure must fail closed (S8), never surface
    // a broken row — see frontend-spec.md S8.
    useErrorBoundary: false,
  });

  return query;
};
